import React, { useState } from 'react';
import Admin from './AdminPanel';
import styles from '../../../styles/adminAuth.module.css';

const PASSWORD = 'princeoladipo';

export default function AdminAuth() {
  const [authed, setAuthed] = useState(() => {
    try { return sessionStorage.getItem('isAdmin') === 'true'; } catch (e) { return false; }
  });
  const [value, setValue] = useState('');
  const [error, setError] = useState(null);

  function submit(e) {
    e.preventDefault();
    if (value === PASSWORD) {
      try { sessionStorage.setItem('isAdmin', 'true'); } catch (e) {}
      setAuthed(true);
      setError(null);
    } else {
      setError('Incorrect password');
    }
  }

  if (authed) return <Admin />;

  return (
    <div className={styles.authcontainer}>
      <div className={styles.authbox}>
        <div className={styles.authheader}>
          <svg xmlns="http://www.w3.org/2000/svg" width="48" height="48" fill="currentColor" viewBox="0 0 16 16">
            <path d="M8 1a2 2 0 0 1 2 2v4H6V3a2 2 0 0 1 2-2zm3 6V3a3 3 0 0 0-6 0v4a2 2 0 0 0-2 2v5a2 2 0 0 0 2 2h6a2 2 0 0 0 2-2V9a2 2 0 0 0-2-2z"/>
          </svg>
          <h1>Admin Access</h1>
        </div>

        <p className={styles.subtitle}>Enter your password to continue</p>

        <form onSubmit={submit} className={styles.form}>
          <div className={styles.formgroup}>
            <label htmlFor="password">Password</label>
            <input
              id="password"
              type="password"
              value={value}
              onChange={(e) => setValue(e.target.value)}
              className={styles.input}
              placeholder="Enter password"
              autoFocus
            />
          </div>

          {error && <div className={styles.error}>{error}</div>}

          <button type="submit" className={styles.submitbtn}>Enter</button>
        </form>

        <div className={styles.footer}>
          <p className={styles.security}>
            <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" fill="currentColor" viewBox="0 0 16 16">
              <path d="M10.854 7.146a.5.5 0 0 1 0 .708l-3 3a.5.5 0 0 1-.708 0l-1.5-1.5a.5.5 0 1 1 .708-.708L7.5 9.793l2.646-2.647a.5.5 0 0 1 .708 0z"/>
              <path d="M8 15A7 7 0 1 1 8 1a7 7 0 0 1 0 14zm0 1A8 8 0 1 0 8 0a8 8 0 0 0 0 16z"/>
            </svg>
            Secure connection
          </p>
        </div>
      </div>
    </div>
  );
}
